export enum DeactivateEventTicketsPackageErrorEnum {
  FREE_TICKETS_SENT = 'FREE_TICKETS_SENT',
  TICKETS_ON_SALE_AND_SOLD = 'TICKETS_ON_SALE_AND_SOLD',
  TICKETS_ON_SALE_NONE_SOLD = 'TICKETS_ON_SALE_NONE_SOLD'
}
